export const hashReplacer = (href) =>{
    if(href===undefined){
        return null;
    }
    return href.replace(/(#\/)/,"")
}